<template>
  <div class="wrapper">
    <div class="top-wrapper">
      <div class="top-left-wrapper">
        <div>{{ data.title }}</div>
        <div>{{ data.location }}</div>
      </div>
      <div class="top-price">{{ data.price | currencyFilter("$", 2) }}</div>
    </div>
    <div class="divider" />
    <div class="bottom-wrapper">
      <div><ProjectItemTechs :techs="data.consultants" /></div>
      <div>{{ data.price | currencyFilter("$", 2) }}</div>
    </div>
  </div>
</template>

<script>
import ProjectItemTechs from "./ProjectItemTechs.vue";

export default {
  props: ["data"],
  components: {
    ProjectItemTechs,
  },
};
</script>


<style scoped>
.wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
}
.wrapper:not(:first-child) {
  margin-top: 12px;
}
.divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0;
}
.top-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-left-wrapper > :first-child {
  font-family: inter-regular;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.top-left-wrapper > :last-child {
  font-size: 13px;
  line-height: 20px;
  color: #969696;
}
.top-price {
  font-size: 16px;
  line-height: 24px;
  color: #969696;
}
.bottom-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  line-height: 20px;
  color: #969696;
}
</style>
